<div class='p-fluid p-field mt-3'>
  <button pButton type='button' icon='pi pi-spin pi-spinner' *ngIf='loading' [label]='label' disabled></button>
  <button pButton type='button' [label]='label' (click)='onLogIn()' *ngIf='!loading' [disabled]='disabled'></button>
</div>
